/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.1
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../../reducers/rootReducer';
import { EWidgetStatus } from '../widgetTypes';
import { IPaymentsHistoryItem, IWidgetPaymentHistoryReducer } from './widgetPaymentHistoryTypes';

export const getPaymentHistory = (state: IRootReducer): IWidgetPaymentHistoryReducer =>
    state.dashboard.widgetPaymentHistory;

export const makeSelectorPaymentHistoryIsLoading =
    (): OutputSelector<IRootReducer, boolean, (state: IWidgetPaymentHistoryReducer) => boolean> =>
        createSelector(
            getPaymentHistory,
            (state: IWidgetPaymentHistoryReducer) => state.loading,
        );

export const makeSelectorPaymentHistoryGetPayments =
    (): OutputSelector<IRootReducer,
        IPaymentsHistoryItem[],
        (state: IWidgetPaymentHistoryReducer) => IPaymentsHistoryItem[]> =>
        createSelector(
            getPaymentHistory,
            (state: IWidgetPaymentHistoryReducer) => state.payments,
        );

export const makeSelectorPaymentHistoryIsError =
    (): OutputSelector<IRootReducer, string, (state: IWidgetPaymentHistoryReducer) => string> =>
        createSelector(
            getPaymentHistory,
            (state: IWidgetPaymentHistoryReducer) => state.error,
        );

export const makeSelectorPaymentHistoryStatus =
    (): OutputSelector<IRootReducer, EWidgetStatus, (state: IWidgetPaymentHistoryReducer) => EWidgetStatus> =>
        createSelector(
            getPaymentHistory,
            (state: IWidgetPaymentHistoryReducer) => state.error
                ? EWidgetStatus.ERROR
                : state.payments.length ? EWidgetStatus.SUCCESS : EWidgetStatus.EMPTY,
        );
